import 'reflect-metadata';
export * from './Services.js';
export * from './IApiService.js';
export * from './IValidate.js';
export * from './Validators.js';
export * from './DependencyValidator.js';
export * from './RestApiService.js';
export * from './qbo-api.js';
export * from './qbo-card.js';
export * from './qbo-contextmenu.js';
export * from './qbo-datalist.js';
export * from './qbo-docviewer.js';
export * from './qbo-fetch.js';
export * from './qbo-form-edit.js';
export * from './qbo-form-element.js';
export * from './qbo-icon.js';
export * from './qbo-json.js';
export * from './qbo-menu.js';
export * from './qbo-microphone.js';
export * from './qbo-paginate.js';
export * from './qbo-popover.js';
export * from './qbo-popup.js';
export * from './qbo-popup-listener.js';
export * from './qbo-resize.js';
export * from './qbo-search.js';
export * from './qbo-select.js';
export * from './qbo-selectable.js';
export * from './qbo-table.js';
export * from './qbo-table-sort.js';
export * from './qbo-tabs.js';
export * from './qbo-user-preferences.js';
export * from './qbo-validate.js';
export * from './styles.js';
export function matches(source, match, wildCard = "*", ignoreCase = true) {
    match = match.replace(/([.+^${}()|[\]\\])/g, '\\$1');
    match = match.replace(new RegExp('\\' + wildCard, 'g'), ".*");
    let regex = new RegExp("^" + match + "$", ignoreCase ? "i" : "");
    return regex.test(source);
}
export function elementData(element) {
    const data = element.dataset;
    const record = {};
    for (const key in data) {
        if (data.hasOwnProperty(key) && data[key] !== undefined) {
            record[key] = data[key];
        }
    }
    return record;
}
export function elementDate(date) {
    if (!date || date.trim() == '')
        return '';
    return new Date(date).toISOString().slice(0, 10);
}
export function elementDateTime(date) {
    if (!date || date.trim() == '')
        return '';
    return new Date(date).toLocaleString().replace(',', '');
}
